import {gql} from '@apollo/client';

import {useCreateLabSubmissionMutation as _useCreateLabSubmissionMutation} from '#apollo/schema';
import {useUpdateLabSubmissionMutation as _useUpdateLabSubmissionMutation} from '#apollo/schema';
import {dashboardQuery} from '#component/page/Dashboard/useDashboard';

export const CreateLabSubmissionMutation = gql`
  mutation CreateLabSubmissionMutation($input: CreateLabSubmissionInput!) {
    labSubmission: createLabSubmission(input: $input) {
      id
    }
  }
`;

export const useCreateLabSubmissionMutation = () => {
  return _useCreateLabSubmissionMutation({
    refetchQueries: [{query: dashboardQuery}],
  });
};

export const UpdateLabSubmissionMutation = gql`
  mutation UpdateLabSubmissionMutation($input: UpdateLabSubmissionInput!) {
    labSubmission: updateLabSubmission(input: $input) {
      id
    }
  }
`;

export const useUpdateLabSubmissionMutation = () => {
  return _useUpdateLabSubmissionMutation({
    refetchQueries: [{query: dashboardQuery}],
  });
};
